const filteredProducts = {
    ADD_FILTERED_PRODUCTS: "ADD_FILTERED_PRODUCTS",
    REMOVE_FILTERED_PRODUCTS: "REMOVE_FILTERED_PRODUCTS"
};

export default filteredProducts;